import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./authcontext";

const RoleBasedRoute = ({
  children,
  allowedRoles = [],
  requiredPermissions = [],
}) => {
  const location = useLocation();
  const { isAuthenticated, canAccess } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!canAccess({ allowedRoles, requiredPermissions })) {
    return <Navigate to="/access-denied" replace state={{ from: location }} />;
  }

  return children;
};

export default RoleBasedRoute;